// extracted by mini-css-extract-plugin
export default {"root":"src-components-Chart-style__zdMNk__root","caption":"src-components-Chart-style__xsN25__caption"};